export default __webpack_public_path__ + "static/wayside_logo-ab8a7d34cb7c45576ff7860fb847884e.svg";